import { DetectorType } from '../../utils/enum';
import { Detector } from '../detector';

export default class extends Detector {

  constructor() {
    super({
      type: DetectorType.DebugLib
    });
  }

  init() {}

  detect() {
    if (
      // eruda 檢測
      (window as any).eruda?._devTools?._isShow === true ||
      // vconsole 檢測
      (!!(window as any)._vcOrigConsole && !!window.document.querySelector('#__vconsole.vc-toggle'))
    ) {
      this.onDevToolOpen();
    }
  }

  static isUsing() {
    return !!(window as any).eruda || !!(window as any)._vcOrigConsole;
  }
}